import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const DeviceAcceptanceView = loadable(() => import('../components/Device/Views/DeviceAcceptanceView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('DeviceAcceptance own props', ownProps);
    return {
        contextCustomer: state.AppReducer.contextCustomer,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('DeviceAcceptance Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
/** @deprecated - No longer used */
export default connect(mapStateToProps, mapDispatchToProps)(DeviceAcceptanceView);
